// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"ccc3da45","453":"9f1408d5","893":"f463b203","905":"030cc01d","976":"d266470a"}[chunkId] + ".chunk.js";
};